var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('AppBar'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Account")]),_c('v-card',[_vm._v(_vm._s(_vm.user))]),_c('v-card',[_vm._v(_vm._s(_vm.isAuthenticated))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }